import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { hasMany, references } from '@apexdesigner/schema-tools';

export const processDesign = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    designUuid: z
      .string()
      .hidden()
      .describe(
        'Unique identifier for this process across all versions. A random UUID for\ndesigns authored in the modeler; a UUID v5 derived from the process name\nby the DSL reader for designs generated from a `*.process.ts` design file.',
      ),

    name: z
      .string()
      .nullable()
      .optional()
      .describe('Internal name of the process'),

    displayName: z
      .string()
      .nullable()
      .optional()
      .describe('Human-readable name shown to users'),

    description: z
      .string()
      .nullable()
      .optional()
      .presentAs('textarea')
      .describe('Explanation of what this process does'),

    version: z.number().describe('Version number, increments with each update'),

    suspended: z
      .boolean()
      .nullable()
      .optional()
      .describe('Whether new instances can be started from this design'),

    sha1Sum: z
      .string()
      .nullable()
      .optional()
      .hidden()
      .describe('Hash of the design for change detection'),

    designJson: z
      .unknown()
      .nullable()
      .optional()
      .presentAs('json')
      .describe('The complete process definition'),

    analysis: z
      .unknown()
      .nullable()
      .optional()
      .presentAs('json')
      .describe('Pre-computed analysis for runtime optimization'),

    createdAt: z.coerce
      .date()
      .nullable()
      .optional()
      .hidden()
      .describe('createdAt'),

    updatedAt: z.coerce
      .date()
      .nullable()
      .optional()
      .hidden()
      .describe('updatedAt'),

    tenantId: z
      .uuid()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to Tenant'),

    processInstances: hasMany('ProcessInstance'),

    processDesignHistories: hasMany('ProcessDesignHistory'),

    processDesignActivityCounts: hasMany('ProcessDesignActivityCount'),

    processInstanceSummaries: hasMany('ProcessInstanceSummary'),

    tenant: references('Tenant'),
  })
  .describe('A versioned process definition that can be instantiated')
  .as('ProcessDesign');

export { processDesign as processDesignSchema };
